import { Tooltip } from "antd"
import UMCCheckbox from "../components/common/UMCCheckbox"
import UMCHoriAttrCompView from "../components/common/UMCHoriAttrCompView"
import { ADD, DELETE, EDIT, FUNC_DETAIL, FUNCTION, NOE_ENTERPRISE, NOE_ESSENTIAL } from "./Constants"
import { formatDictString, getImage, getThemedImage, getTranslated } from "./CommonUtils"
import _ from "lodash"
import parse from 'html-react-parser'


export const getTabClassName = (actionMode) => {
    switch (actionMode) {
        case FUNCTION:
            return "tab-disabled"
        case FUNC_DETAIL:
            return "tab-disabled tab-width-100"
        default:
            return ""
    }
}

export const isLockedCell = (cell) => {
    const lockedkey = cell?.find(item => item.id === "lockedkey")

    return lockedkey?.value === "Yes" ? true : false
}

/* Return the dynamic current label. If that's empty, return the static label  */
export const getLabel = (cell) => {
    const labelAttr = cell.attribute?.find(item => item.id === "label")

    return labelAttr?.value || getTranslated(null, cell.label)
}

// Get view for ADD/EDIT mode
export const getAddView = (allTabs, activeTab, actionMode, handleCellChange) => {

    if(!allTabs?.length || !allTabs[activeTab]) return <></>

    return allTabs[activeTab]?.map(cell => {
        // if(cell?.action === DELETE) return <div className="pkey-col cursor-default"></div> // Show nothing if selected for DELETE already

        const isLocked = cell.attribute?.length ? isLockedCell(cell.attribute[0].attribute) : false
        return <Tooltip title={(!isLocked) ? `${getTranslated(null, "LABEL_KEY")} ${cell.keyid}` : null} placement="topLeft">
            <span>
                {
                // (cell.isHardKey) ? <div className="pkey-col hard-key-disable">Hard key</div> :

                cell.attribute?.length ?
                    <div className={`pkey-col ${(actionMode === EDIT) ? "cursor-pointer" : "cursor-default"} ${isLocked ? "lock-block" : ""} ${cell.error ? "pk-cell-error" : ""}`} onClick={() => (actionMode === EDIT) ? handleCellChange(FUNC_DETAIL, cell?.attribute?.length ? cell : []) : {}}>
                        <Tooltip title={isLocked ? `${getTranslated(null, "LABEL_KEY")} ${cell.keyid}` : null} placement="topLeft">
                            <div className="cell-block-1">
                                <img className="func-icon" src={getImage(cell.attribute[0].iconName)} alt={cell.attribute[0].iconName} />
                                <div>{getLabel(cell.attribute[0])}</div>
                            </div>
                        </Tooltip>
                        {isLocked ? // For lock handling in both ADD & EDIT
                            <Tooltip title={getTranslated(null, "MSG_PROGKEY_LOCKED")}>
                                <img className="lock-icon" src={getImage("icon_lock_red.svg")} alt={"Cell is locked"} />
                            </Tooltip> : <></>}
                    </div> : // Show add icon in ADD mode, empty in EDIT mode
                    <div className={`pkey-col ${actionMode === ADD ? "cursor-pointer" : "cursor-default"}`} onClick={() => actionMode === ADD ? handleCellChange(FUNCTION, cell) : {}}>
                        {actionMode === ADD ? <img src={getImage("icon_addprogkey.svg")} alt="Add key button" /> : <></>}
                    </div>}
            </span>
        </Tooltip>
    })
}

//Get custom action view [COPY | MOVE] - todo
export const getCustomActionView = (allTabs, activeTab, actionMode, handleCustomActions, srcId, destId) => {

    return allTabs?.length && allTabs[activeTab]?.map(cell => {

        // if(cell?.action === DELETE) return <div className="pkey-col cursor-default"></div> // Show nothing if selected for DELETE already

        const isLocked = cell.attribute?.length ? isLockedCell(cell.attribute[0].attribute) : false

        return <Tooltip title={(!isLocked) ? `${getTranslated(null, "LABEL_KEY")} ${cell.keyid}` : null} placement="topLeft">
            <span>
                {
                // (cell.isHardKey) ? <div className="pkey-col hard-key-disable">Hard key</div> :

                (cell.attribute?.length && (!(destId && cell.action === DELETE))) ?
                    <div
                        className={`pkey-col ${(!srcId && !isLocked) ? "cursor-pointer" : "cursor-default"} ${isLocked ? "lock-block" : ""} ${(srcId && !destId) && (cell.id === srcId ? "pk-custm-sel" : "pk-custm-disable")}`}
                        onClick={() => (!actionMode.includes("ACTIVE") && !isLocked && !destId) ? handleCustomActions(cell, "SRC") : {}}
                    >
                        <Tooltip title={isLocked ? `${getTranslated(null, "LABEL_KEY")} ${cell.keyid}` : null} placement="topLeft">
                            <div className="cell-block-1">
                                <img className="func-icon" src={getImage(cell.attribute[0].iconName)} alt={cell.attribute[0].iconName} />
                                <div>{getLabel(cell.attribute[0])}</div>
                            </div>
                        </Tooltip>
                        {isLocked ? //Lock view handling in all custom modes
                            <Tooltip title={getTranslated(null, "MSG_PROGKEY_LOCKED")}>
                                <img className="lock-icon" src={getImage("icon_lock_red.svg")} alt={"Cell is locked"} />
                            </Tooltip> : <></>}
                    </div> : // Show add icon in ADD mode, empty in EDIT mode
                    <div className={`pkey-col ${actionMode.includes("ACTIVE") ? "cursor-pointer" : "cursor-default"} ${actionMode.includes("ACTIVE") ? "pk-active-cell" : ""}`} onClick={() => actionMode.includes("ACTIVE") ? handleCustomActions(cell) : {}}>
                        {actionMode.includes("ACTIVE") ? <img src={getThemedImage(`light-icon-${actionMode.replace("_ACTIVE", "")?.toLowerCase()}.svg`)} alt="Add key action" /> : <></>}
                    </div>}
            </span>
        </Tooltip>
    })
}

//Get DELETE action view - todo
export const getDeleteActionView = (allTabs, activeTab, actionMode, handleDeleteActions) => {

    return allTabs?.length && allTabs[activeTab]?.map(cell => {

        // if(cell?.action && cell.action !== DELETE) return <div className="pkey-col cursor-default"></div> // Show nothing if selected for DELETE already

        const isLocked = cell.attribute?.length ? isLockedCell(cell.attribute[0].attribute) : false

        return <Tooltip title={(!isLocked) ? `${getTranslated(null, "LABEL_KEY")} ${cell.keyid}` : null} placement="topLeft">
            <span>
                {
                // (cell.isHardKey) ? <div className="pkey-col hard-key-disable">Hard key</div> :

                cell.attribute?.length ?
                    <div
                        className={`pkey-col ${(cell.action === DELETE) ? "pk-active-del-cell" : ""} ${isLocked ? "lock-block cursor-default" : ""}`}
                        onClick={() => (!isLocked) ? handleDeleteActions(cell) : {}}
                    >
                        <Tooltip title={isLocked ? `${getTranslated(null, "LABEL_KEY")} ${cell.keyid}` : null} placement="topLeft">
                            <div className="cell-block-1">
                                <img className="func-icon" src={getImage(cell.attribute[0].iconName)} alt={cell.attribute[0].iconName} />
                                <div>{getLabel(cell.attribute[0])}</div>
                            </div>
                             {(cell.action === DELETE) ? <div className="pk-del-overlay-icon"><img src={getThemedImage(`light-icon-delete.svg`)} alt="delete"/></div> : <></>}
                        </Tooltip>
                        {isLocked ? //Lock view handling in all custom modes
                            <Tooltip title={getTranslated(null, "MSG_PROGKEY_LOCKED")}>
                                <img className="lock-icon" src={getImage("icon_lock_red.svg")} alt={"Cell is locked"} />
                            </Tooltip> : <></>}
                    </div> 
                    : // Show add icon in ADD mode, empty in EDIT mode
                    <div className={`pkey-col ${actionMode === ADD ? "cursor-pointer" : "cursor-default"}`}>
                    </div>
                    }
            </span>
        </Tooltip>
    })
}

// Get view for FUNCTION mode
export const getFunctionView = (functions, handleCellChange) => {

    return functions.map(item =>
        <div className="pkey-col func-block" onClick={() => handleCellChange(FUNC_DETAIL, item)}>
            <img className="func-icon" src={getImage(item.iconName)} alt={item.iconName} />
            <div>{getTranslated(null, item.label)}</div>
        </div>
    )
}

// Get view for FUNC_DETAIL mode
export const getFuncDetailView = (currFuncAttrs, handleSchemaDataChange) => {

    const currFuncAttrsTemp = _.cloneDeep(currFuncAttrs?.attribute)

    return <div className="pk-func-detail-block" style={{ display: "block" }}>
        <div className="pkey-col func-detail-label cursor-default">
            <img className="func-icon" src={getImage(currFuncAttrs.iconName)} alt={currFuncAttrs.iconName} />
            {/* <div>{currFuncAttrsTemp?.find(item => item.id === "label")?.value || getTranslated(null, currFuncAttrs.label)}</div> */}
            <div>{currFuncAttrsTemp ? getLabel(currFuncAttrs): ""}</div>
        </div>

        {currFuncAttrsTemp?.map((attribute, index) => {
            if(attribute.access === "INTERNAL") return null

            if (attribute.id !== "lockedkey")
                return <UMCHoriAttrCompView attribute={{ ...attribute, customHandleDataChange: handleSchemaDataChange }} key={index} />
            else {
                const attr = { ...attribute, className: "pk-lock-checkbox", handleSchemaDataChange: handleSchemaDataChange }

                return <UMCCheckbox {...attr} key={index} />
            }
        })}
    </div>
}

export const processFuncAttr = (data) => {

    return {
        ...data,
        attribute: data.attribute.map(attr => ({
            ...attr,
            value: attr.defaultValue || ""
        }))
    }
}

export const getAddonOptions = (progkeycategory, dict) => { // Don't move the options to Constant.js file, it'll cause issue on translation application
    if (progkeycategory === NOE_ENTERPRISE) {
        return [
            { value: "ale-120-0", label: <>{parse(formatDictString(dict, "LABEL_PK_ADN_EXPANSION", { addon: "ALE-120" }))}</> },
            { value: "ale-120-1", label: <>1 x ALE-120<span className="radio-sub-info"> ({getTranslated(dict, "LABEL_MULTI_PAGES")})</span></> },
            { value: "ale-120-2", label: "2 x ALE-120" },
            { value: "ale-120-3", label: "3 x ALE-120" }]
    } else if (progkeycategory === NOE_ESSENTIAL) {
        return [
            { value: "em-200-0", label: <>{parse(formatDictString(dict, "LABEL_PK_ADN_EXPANSION", { addon: "1 x EM200" }))}</> },
            { value: "em-200-1", label: <>1 x EM200<span className="radio-sub-info"> ({getTranslated(dict, "LABEL_MULTI_PAGES")})</span></> },
            { value: "em-200-2", label: "2 x EM200" },
            { value: "em-200-3", label: "3 x EM200" }]
    } else { // progkeycategory === NOE_IPDSP
        return [
            { value: "ipdsp-0", label: <>{getTranslated(dict, "LABEL_WITHOUT_ADDON")}</> },
            { value: "ipdsp-1", label: <>{`${formatDictString(dict, "LABEL_IPDSP_ADDON", { addon: 10 })}`}</> },
            { value: "ipdsp-2", label: <>{`${formatDictString(dict, "LABEL_IPDSP_ADDON", { addon: 40 })}`}</> },
            { value: "ipdsp-3", label: <>{`${formatDictString(dict, "LABEL_IPDSP_ADDON", { addon: "(40 + 10)" })}`}</> }]
    }
}

export const getDeviceGenericType = (progkeycategory) => {
    return progkeycategory.includes("NOE") ? "NOE" : "SIP"
}